import { GET_LIST } from 'react-admin';
import { sortBy } from 'lodash';

export default {
  [GET_LIST]: ({ response }) => ({
    ...response,
    json: sortBy(response.json, [(item) => item.code !== 'US', (item) => item.name]),
  }),
};
